import { IAcceptanceItem, ILegalDocs } from '@logicalcommander/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface ILegalDocsState {
  legalDocs: ILegalDocs
  legalVersionsCurrent: ILegalDocs
  acceptances: IAcceptanceItem[]
}

const initialState: ILegalDocsState = {
  legalDocs: {} as ILegalDocs,
  legalVersionsCurrent: {} as ILegalDocs,
  acceptances: [] as IAcceptanceItem[],
}

export const legalDocsSlice = createSlice({
  name: 'legalDocsReducer',
  initialState,
  reducers: {
    setLegalDocs: (state, action: PayloadAction<ILegalDocs>) => {
      state.legalDocs = action.payload
    },
    setLegalVersionsCurrent: (state, action: PayloadAction<ILegalDocs>) => {
      state.legalVersionsCurrent = action.payload
    },
    setAcceptances: (state, action: PayloadAction<IAcceptanceItem[]>) => {
      state.acceptances = action.payload
    },
  },
})

export const selectLegalDocs = (state: RootState): ILegalDocsState => state.legalDocsReducer
export const selectLegalVersionsCurrent = (state: RootState): ILegalDocs => state.legalDocsReducer.legalVersionsCurrent
export const { setLegalDocs, setLegalVersionsCurrent, setAcceptances } = legalDocsSlice.actions
export default legalDocsSlice.reducer
